
const GTMScript = {
  isScriptExist : function(remove=false) {
    const scriptTagNum = document.querySelectorAll('script');
    let isPresent = false;
    let scriptTag = null
    for(let i = 0; i < scriptTagNum.length; i++ ) {
      let srcText = scriptTagNum[i].getAttribute('src')
      if(srcText && srcText.includes('gtm.js')) {
        scriptTag = scriptTagNum[i]
        isPresent = true
        break;
      }
    }
    if(remove) {
      scriptTag.parentNode.removeChild(scriptTag)
      return
    }
    return isPresent
  },
  initialise : function (gtmId, source="not_set") {
    if(this.isScriptExist()) {
      return
    }
    
    // this is log event to check if consentstates were present in window.splashLearnGtmConsentObj which is required 
    // for consent based tag firing on GTM.
    // @ts-ignore global function
    let isGTMConsentPresent = typeof window.splashLearnGtmConsentObj !== "undefined";
    trackAnalyticsEvent("GTM SCRIPT initialised From SPA",{'eventSource': source, 'isGTMConsentPresent': isGTMConsentPresent})
    
    let dataLayer = `window.dataLayer = window.dataLayer || [];`

    let gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');`

    let iframeGtm = `<!-- Google Tag Manager (noscript) -->
        <iframe src="https://www.googletagmanager.com/ns.html?id='${gtmId}'"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        <!-- End Google Tag Manager (noscript) -->`
        
    let addDataLayer = document.createElement('script');
    let scriptTag = document.createElement('script');
    let noscript = document.createElement('noscript');
    
    // insert id to the tag.
    addDataLayer.id = 'splashDataLayer';
    scriptTag.id = 'splashGtmScript';
    noscript.id = 'splashGtmNoscript';

    addDataLayer.innerHTML = dataLayer;
    scriptTag.innerHTML = gtmScript
    noscript.innerHTML = iframeGtm

    document.head.insertBefore(addDataLayer, document.head.childNodes[0]);
    document.head.insertBefore(scriptTag, document.head.childNodes[0]);
    document.body.insertBefore(noscript, document.body.childNodes[0]);
  },
  destroyGtm : function() {
    if(document.getElementById('splashGtmScript')) {
      let splashDataLayer = document.getElementById('splashDataLayer');
      let splashGtmScript = document.getElementById('splashGtmScript');
      let splashGtmNoscript = document.getElementById('splashGtmNoscript');

      splashDataLayer && splashDataLayer.parentNode.removeChild(splashDataLayer)
      splashGtmScript && splashGtmScript.parentNode.removeChild(splashGtmScript)
      splashGtmNoscript && splashGtmNoscript.parentNode.removeChild(splashGtmNoscript)

      this.isScriptExist(true);
    }
  }
}

module.exports = GTMScript